import { makeTintingRequest } from "../makeTintingRequest";

import { GetTintingCostresponse } from "./getTintingCost.typed";

export const getTintingCost = async (id: string) => {
  return await makeTintingRequest<GetTintingCostresponse>({
    url: `/v1/calc?id=${id}`,
    method: "GET",
  });
};
